/** App-level hooks for pausing the notifications SSE during HTTP pool recovery. */

let abortStreamHandler = null;
const recoveryCompleteListeners = new Set();

export function registerNotificationStreamAbort(handler) {
    abortStreamHandler = handler;
}

export function unregisterNotificationStreamAbort(handler) {
    if (abortStreamHandler === handler) abortStreamHandler = null;
}

export function abortNotificationStreamForRecovery() {
    try {
        abortStreamHandler?.();
    } catch {
        // ignore
    }
}

export function subscribeNotificationStreamRecoveryComplete(listener) {
    recoveryCompleteListeners.add(listener);
    return () => recoveryCompleteListeners.delete(listener);
}

export function notifyNotificationStreamRecoveryComplete() {
    for (const listener of recoveryCompleteListeners) {
        try {
            listener();
        } catch {
            // ignore
        }
    }
}
